import React from "react";
import { useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Box from "../UI/Box";
import Container from "../UI/Container";
import logo from "../images/logo.png";
import { useState } from "react";

function Header() {
  const navigate = useNavigate();
  const [mobile, setmobile] = useState(false);
  const search = useRef();
  const submitHandler = (e) => {
    e.preventDefault();
    navigate(`/posts?search=${search.current.value}`);
  };
  return (
    <Box borderRadius={false} animation={false}>
      <Container>
        <Wrapper className={`${mobile ? "mobile" : ""}`}>
          <a href="#" className="logo flex">
            <img src={logo} alt="" />
          </a>
          <form
            className={`search-input ${mobile ? "mobile" : ""}`}
            onSubmit={submitHandler}
          >
            <svg
              onClick={submitHandler}
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 512 512"
              style={{ "flex-shrink": " 0" }}
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
            </svg>
            <input
              onSubmit={submitHandler}
              ref={search}
              type="text"
              placeholder="Discover news, articles and more..."
              aria-label="Search"
            ></input>
          </form>
          <div className="menu flex">
            <div class="flex">
              <NavLink activeclassname="active" to="/">
                Home
              </NavLink>
              <NavLink activeclassname="active" to="/posts">
                Posts
              </NavLink>
              <NavLink activeclassname="active" to="/profile">
                Profile
              </NavLink>
              <img
                onClick={() => setmobile(!mobile)}
                className="search-icon"
                width="28px"
                src="https://img.icons8.com/external-others-ghozy-muhtarom/32/undefined/external-find-management-flat-others-ghozy-muhtarom.png"
              />
            </div>
            {/* <div className="mode-switcher flex">
              <div></div>
              <svg
                stroke="currentColor"
                fill="currentColor"
                stroke-width="0"
                viewBox="0 0 512 512"
                class="css-uk6cul"
                height="16"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"></path>
              </svg>
            </div> */}
          </div>
        </Wrapper>
      </Container>
    </Box>
  );
}

export default Header;

const Wrapper = styled.div`
  padding: 24px 0;
  display: flex;
  justify-content: space-between;

  @media (max-width: 991px) {
    height: 106px;
    &::before {
      position: fixed;
      width: 100%;
      height: 0%;
      content: "";
      background-color: #00000061;
      left: 0;
      z-index: 2;
      top: 106px;
      transform: all 0.2s;
    }
    &.mobile::before {
      height: 100%;
    }
    .search-icon {
      display: block !important;
      cursor: pointer;
    }
  }
  @media (max-width: 520px) {
    height: 70px;
  }
  .search-icon {
    display: none;
    @media (max-width: 520px) {
      width: 20px;
    }
  }
  .search-input {
    display: flex;
    align-items: center;
    background-color: #e2e8f0;
    border-radius: 8px;
    padding: 8px 16px;
    gap: 8px;
    width: 100%;
    max-width: 420px;
    @media (max-width: 991px) {
      position: absolute;
      top: -100%;
      max-width: 100vw;
      border-radius: 0;
      padding: 16px 32px;
      z-index: 99;
      left: 0;
      opacity: 0;
      transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      &.mobile {
        top: 100%;
        opacity: 1;
      }
    }
    @media (max-width: 767px) {
      font-size: 14px;
    }

    svg path {
      fill: #718096;
    }
    input {
      color: #718096;
      width: 100%;
      padding: 0 0.5rem;
      border: none;
      background-color: transparent;
      outline: none;
      appearance: none;
      font-size: inherit;
      line-height: inherit;
      border-radius: 4px;
      font-family: "Hind", sans-serif;
    }
  }
  .logo {
    img {
      width: 100px;
      @media (max-width: 520px) {
        width: 60px;
      }
    }
  }
  .menu {
    .flex {
      gap: 24px;
      @media (max-width: 520px) {
        gap: 18px;
      }
    }
    a {
      font-family: "Hindi", sans-serif;
      font-weight: 700;
      text-decoration: none;
      color: #718096;
      @media (max-width: 520px) {
        font-size: 14px;
      }
    }
  }
  .mode-switcher {
    margin-left: 24px;
    background-color: #fd9f5d;
    border-radius: 16px;
    padding: 4px;
    padding-left: 6px;
    justify-content: space-between;
    cursor: pointer;
    div {
      width: 20px;
      margin-left: -4px;
      height: 20px;
      aspect-ratio: 1/1;
      border-radius: 50%;
      background-color: #fff;
    }
    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26); */
    svg path {
      fill: white;
    }
    width: 50px;
    height: 24px;
    svg {
      flex: 0 0 20px;
      margin-left: -100%;
    }
  }
`;
